import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { CSDict } from "../api-interfaces";

export interface TypeData {
  label: string;
  value: string;
  permissions: CSDict[];
}

const initialState = {
  typeData: [] as TypeData[],
};

const typeDataSlice = createSlice({
  name: "typeData",
  initialState,
  reducers: {
    createTypeData: (state, action: PayloadAction<TypeData[]>) => {
      state.typeData = action.payload;
    },
  },
});

export const { createTypeData } = typeDataSlice.actions;

export default typeDataSlice.reducer;
